<template>
  <b-modal v-model="modalOpen" centered hide-footer hide-header>
    <div class="late-offer-modal">
      <div class="late-offer-modal__icon">
        <img src="/src/assets/img/plus.svg" alt="Gjenåpne ikon" />
      </div>
      <div class="late-offer-modal__content">
        <h5 class="late-offer-modal__title">Gjenåpne prisforespørsel?</h5>
        <p class="late-offer-modal__description">
          Er du sikker på at du vil gjenåpne denne prisforespørselen?
        </p>
      </div>
      <div class="late-offer-modal__footer">
        <BaseButton
          variant="primary"
          :text="loading ? 'Gjenåpner...' : 'Ja, gjenåpne'"
          :disabled="loading"
          @click="handleConfirm"
        >
          <b-spinner v-if="loading" small />
        </BaseButton>
        <BaseButton
          variant="secondary"
          :text="loading ? 'Avbryter...' : 'Avbryt'"
          :disabled="loading"
          @click="handleCancel"
        />
      </div>
    </div>
  </b-modal>
</template>

<script setup lang="ts">
import { ref, watch } from "vue";
import BaseButton from "@/components/Base/BaseButton/BaseButton.vue";

const props = defineProps<{ open: boolean }>();
const emit = defineEmits(["update:open", "confirm"]);

const modalOpen = ref(props.open);
const loading = ref(false);

watch(
  () => props.open,
  (val) => {
    modalOpen.value = val;
  },
);

watch(modalOpen, (val) => {
  emit("update:open", val);
});

const handleConfirm = async () => {
  loading.value = true;
  await emit("confirm");
  loading.value = false;
  modalOpen.value = false;
};

const handleCancel = () => {
  if (loading.value) return;
  modalOpen.value = false;
};
</script>

<style scoped>
.late-offer-modal {
  width: 100%;
  padding: 24px;
  background: white;
  border-radius: 8px;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  gap: 24px;
}
.late-offer-modal__icon {
  width: 40px;
  height: 40px;
  position: relative;
}
.late-offer-modal__content {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  gap: 8px;
}
.late-offer-modal__title {
  width: 366.27px;
  text-align: center;
  color: #1d1d1d;
  font-size: 18px;
  font-family: Montserrat, sans-serif;
  font-weight: 700;
  word-wrap: break-word;
}
.late-offer-modal__description {
  width: 366.27px;
  text-align: center;
  color: #1d1d1d;
  font-size: 16px;
  font-family: Montserrat, sans-serif;
  font-weight: 400;
  word-wrap: break-word;
}
.late-offer-modal__footer {
  display: inline-flex;
  justify-content: flex-start;
  align-items: flex-start;
  gap: 14px;
}
.spinner {
  display: inline-block;
  width: 16px;
  height: 16px;
  border: 2px solid #fff;
  border-top: 2px solid #ecba4e;
  border-radius: 50%;
  animation: spin 0.7s linear infinite;
  margin-right: 6px;
  vertical-align: middle;
}
@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
</style>
